export const defaultProps = {
  dataRowHeight: 50,
  titleRowHeight: 35,
  headerRowHeight: 35,
  filterRowHeight: 40,
  rowGap: 15,
} as const;
